module.exports = __webpack_public_path__ + "static/bottom-47f1c5b3e1cbbf2d2186c0e668d53a53.png";